exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.payBox[data-v-67a8c6da] {\n  height: 100%;\n  min-height: 100%;\n}\n.payBox .padding25_top[data-v-67a8c6da] {\n  padding-top: 2.5rem;\n}\n.payBox .payImg img[data-v-67a8c6da] {\n  width: 2.75rem;\n  height: 2.75rem;\n}\n.payBox .btn[data-v-67a8c6da] {\n  width: 8.25rem;\n  height: 2rem;\n  line-height: 2rem;\n  background: #ffffff;\n  border-radius: 5rem;\n  border: 0.05rem solid #FC5D7B;\n}\n.red[data-v-67a8c6da] {\n  color: #FC5D7B;\n}", ""]);

// exports
